// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.scribe.EncounterScribeSessionFieldValueResponse */
/* istanbul ignore next */
@GandalfModel
export class EncounterScribeSessionFieldValueResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	fieldName!: string;

	@GandalfProperty({ designType: String })
	fieldValue!: string;

	@GandalfProperty({ designType: String })
	testName!: string;

}
